import React, { useState, useEffect, useCallback } from 'react';
import './SplashScreen.css';
import RetroScene from './RetroScene';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('enter'); // enter | hold | exit

  const exit = useCallback(() => {
    setPhase('exit');
    setTimeout(onComplete, 900);
  }, [onComplete]);

  useEffect(() => {
    // Hold after entrance animation, then auto-advance
    const holdTimer = setTimeout(() => setPhase('hold'), 800);
    const exitTimer = setTimeout(exit, 4200);
    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
    };
  }, [exit]);

  return (
    <div className={`splash-screen ${phase}`} onClick={phase === 'hold' ? exit : undefined}>
      {/* Retrowave scene — clover sun over a neon grid (classes from OS_Page.css) */}
      <RetroScene splash />

      <div className="splash-scanlines" />

      <div className="splash-content">
        <div className="splash-title">S.O.S</div>
        {/* always rendered so its height is reserved — no layout shift */}
        <div className={`splash-prompt${phase === 'hold' ? ' visible' : ''}`}>
          [ TAP TO ENTER ]
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
